var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"backdropy pa-0",style:(_vm.backdropimage),attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('sign-in-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }